export enum ORDER_STATUS {
    CREATED = 'created',
    PENDING = 'pending',
    DONE = 'done',
}